import { isTrustedOrigin } from './trusted-origin'
import type { AddTaskOptions, TDOpts } from './types'
import './types'

// IE-specific DOM API type for legacy browser support
type IEElement = Element & {
    attachEvent?(type: string, listener: EventListener): boolean
}

// Custom element types for DOM elements with added properties
type CollapsibleElement = HTMLElement & {
    collapsed?: boolean
}

// Legacy Event type with IE-specific properties
type LegacyEvent = Event & {
    srcElement?: EventTarget | null
}

// Legacy HTMLIFrameElement with deprecated attributes
type LegacyIFrame = HTMLIFrameElement & {
    frameBorder: string
    border: string
}

top.TDOpts = {
    zIndex: 8,
    gmail_holder_left_pos: null,
    delayed_loading: true,
    collapsed: true,

    // These will be assigned later in the file
    placeWindow: () => {},
    collapseWindow: () => {},
    addAsTask: () => {},

    customPostion: (holder: HTMLElement): void => {
        const g_left_pos = top.TDOpts.gmail_holder_left_pos
        if (g_left_pos) {
            holder.style.left = `${g_left_pos - holder.offsetWidth - 5}px`
        }
    },

    listen: (evnt: string, elem: Element, func: EventListener): boolean | undefined => {
        if (elem.addEventListener) {
            elem.addEventListener(evnt, func, false)
        } else {
            // IE DOM fallback
            const ieElem = elem as IEElement
            if (ieElem.attachEvent) {
                return ieElem.attachEvent(`on${evnt}`, func)
            }
        }
    },
}
;(() => {
    if (top?.location.pathname.indexOf('/mail/') === -1) return
    if (top?.location.href.indexOf('&view=ma') !== -1) return
    if (top?.location.href.indexOf('&view=pt') !== -1) return

    const TD_OPTS = top.TDOpts || ({} as TDOpts)
    const ANY_OPTS: { timeout_collapse?: NodeJS.Timeout } = {}

    const doc = top.document

    //
    // --- Toggle ---
    //
    const cur_elm = doc.getElementById('todoist_holder')
    if (cur_elm && cur_elm.style.display !== 'none') {
        cur_elm.style.display = 'none'
        return true
    } else if (cur_elm) {
        cur_elm.style.display = 'block'
        return true
    }

    //
    // --- Create ---
    //

    // --- Helpers
    function getWindowSize(doc?: Document): { w: number; h: number } {
        doc = doc || top.document
        let win_w: number, win_h: number
        if (self.innerHeight) {
            win_w = self.innerWidth
            win_h = self.innerHeight
        } else if (doc.documentElement?.clientHeight) {
            win_w = doc.documentElement.clientWidth
            win_h = doc.documentElement.clientHeight
        } else if (doc.body) {
            win_w = doc.body.clientWidth
            win_h = doc.body.clientHeight
        }
        return { w: win_w || 0, h: win_h || 0 }
    }

    // Create icon
    function createIcon(top_pos: number, click_fn?: EventListener): HTMLImageElement {
        const img = doc.createElement('img')

        img.src = 'https://d3ptyyxy2at9ui.cloudfront.net/76084e29cb2cf72b320e888edc583dfb.gif'
        img.width = 24
        img.height = 24
        img.style.background =
            'transparent url(https://d3ptyyxy2at9ui.cloudfront.net/gmail-plugin-buttons-v3@2x.png) 0 0 no-repeat'
        img.style.backgroundSize = '24px'
        img.style.backgroundPosition = `0 ${top_pos}px`
        img.style.opacity = '0.5'
        img.style.marginLeft = '5px'

        listen('mouseover', img, () => {
            img.style.opacity = '1.0'
            img.style.backgroundColor = '#737373'
        })

        listen('mouseout', img, () => {
            img.style.opacity = '0.5'
            img.style.backgroundColor = 'transparent'
        })

        if (click_fn) listen('click', img, click_fn)

        return img
    }

    function postMessageToWindow(win: Window | null, message: string): boolean {
        try {
            win?.postMessage(message, '*')
            return true
        } catch {
            return false
        }
    }

    function listen(evnt: string, elem: Element, func: EventListener): boolean | undefined {
        if (elem.addEventListener) {
            elem.addEventListener(evnt, func, false)
        } else {
            // IE DOM fallback
            const ieElem = elem as IEElement
            if (ieElem.attachEvent) {
                return ieElem.attachEvent(`on${evnt}`, func)
            }
        }
    }

    // --- Icon functions
    function closeWindow(): boolean {
        setTimeout(() => {
            const todoistHolder = doc.getElementById('todoist_holder')
            if (todoistHolder) {
                todoistHolder.style.display = 'none'
            }

            if (TD_OPTS.onCloseWindow) TD_OPTS.onCloseWindow()
        }, 50)
        return false
    }

    function collapseWindow(): void {
        if (ANY_OPTS.timeout_collapse) {
            clearTimeout(ANY_OPTS.timeout_collapse)
            ANY_OPTS.timeout_collapse = undefined
        }

        if (holder.collapsed) {
            iframe.style.display = 'block'
            holder.collapsed = false
            placeWindow()
        } else {
            iframe.style.display = 'none'
            holder.collapsed = true
            placeWindow()
        }

        if (collapse_icon && holder.collapsed) collapse_icon.style.backgroundPosition = '0 -24px'
        else collapse_icon.style.backgroundPosition = '0 -48px'
    }

    TD_OPTS.collapseWindow = collapseWindow

    // Create holder
    const holder = doc.createElement('div') as CollapsibleElement
    holder.id = 'todoist_holder'
    holder.style.position = 'fixed'
    holder.style.backgroundColor = '#fff'
    holder.style.fontFamily = 'sans-serif'
    holder.style.fontSize = '12px'
    holder.style.zIndex = String(TD_OPTS.zIndex || 134343443)
    holder.style.borderTopRightRadius = '5px'
    holder.style.borderTopLeftRadius = '5px'

    TD_OPTS.holder = holder

    //Create the top
    const top_frame = doc.createElement('div')
    top_frame.style.color = '#fff'
    top_frame.style.padding = '2px'
    top_frame.style.padding = '10px'
    top_frame.style.paddingLeft = '14px'
    top_frame.style.paddingRight = '8px'
    top_frame.style.backgroundColor = '#404040'
    top_frame.style.cursor = 'pointer'
    top_frame.style.textAlign = 'left'
    top_frame.style.fontSize = '13px'

    // New Gmail optimization
    top_frame.style.fontFamily = 'Roboto,RobotoDraft,Helvetica,Arial,sans-serif'
    top_frame.style.fontWeight = '500'
    top_frame.style.lineHeight = '20px'
    top_frame.style.borderRadius = '4px 4px 0 0'

    // Icons holder
    const icons_holder = doc.createElement('div')
    icons_holder.style.cssText = 'margin-top: -5x; float: right; text-align: right; width: 90px;'
    icons_holder.style.marginTop = '-5px'
    icons_holder.style.float = 'right'
    icons_holder.style.textAlign = 'right'
    icons_holder.style.width = '90px'

    let collapse_icon: HTMLImageElement

    if (TD_OPTS.collapsed) {
        collapse_icon = createIcon(-24, collapseWindow)
        icons_holder.appendChild(collapse_icon)
    } else {
        collapse_icon = createIcon(-48, collapseWindow)
        icons_holder.appendChild(collapse_icon)
    }

    if (TD_OPTS.hide_close_icon !== true) icons_holder.appendChild(createIcon(0, closeWindow))

    top_frame.appendChild(icons_holder)

    top_frame.appendChild(doc.createTextNode('Todoist'))

    // Iframe
    const iframe = doc.createElement('iframe') as LegacyIFrame
    iframe.id = 'todoist_iframe'

    //Place the element in the right
    function placeWindow(): void {
        const win_size = getWindowSize()

        let width = 450
        let height = 550
        if (win_size.w > 800) {
            width = 475
            height = 625
        }

        if (win_size.h <= 786) {
            height = 575
        }

        if (win_size.h <= 650) {
            height = 515
        }

        if (holder.collapsed) {
            holder.style.width = '170px'
            holder.style.boxShadow = 'none'
        } else {
            holder.style.width = `${width}px`
            iframe.style.width = `${width}px`
            holder.style.boxShadow =
                '0 8px 10px 1px rgba(0,0,0,0.14), 0 3px 14px 2px rgba(0,0,0,0.12), 0 5px 5px -3px rgba(0,0,0,0.2)'
        }

        iframe.height = String(height - top_frame.offsetHeight)

        holder.style.bottom = '-1px'
        holder.style.left = `${win_size.w - holder.offsetWidth - 30}px`

        if (TD_OPTS.customPostion) {
            TD_OPTS.customPostion(holder)
        }
    }

    TD_OPTS.placeWindow = placeWindow

    // Click fn
    listen('click', top_frame, (ev: Event) => {
        const legacyEv = ev as LegacyEvent
        const elm = legacyEv.srcElement || ev.target

        if (elm && (elm as Element).nodeName.toLowerCase() === 'img') return true

        collapseWindow()
    })

    holder.appendChild(top_frame)

    // Crate the iframe
    iframe.src = chrome.runtime.getURL('frame.html')
    iframe.id = 'todoist_iframe'
    iframe.frameBorder = '0'
    iframe.border = '0'
    iframe.style.margin = '0px'
    iframe.style.padding = '0px'
    holder.appendChild(iframe)

    const body = doc.getElementsByTagName('body')[0]

    holder.style.visibility = 'hidden'

    body.appendChild(holder)

    window.addEventListener('scroll', placeWindow)
    window.addEventListener('resize', placeWindow)

    placeWindow()

    if (TD_OPTS.delayed_loading) {
        holder.style.visibility = 'hidden'
        ANY_OPTS.timeout_collapse = setTimeout(() => {
            holder.style.visibility = 'visible'
            if (!holder.collapsed) collapseWindow()
        }, 1000)
    } else {
        holder.style.visibility = 'visible'
    }

    let _IS_INITED = false

    top?.addEventListener('message', (e: MessageEvent) => {
        let str_data = e.data
        if (!str_data || typeof str_data.indexOf !== 'function') return

        if (!isTrustedOrigin(e.origin)) return

        if (str_data.indexOf('SWITCH_URL:') !== -1) {
            str_data = str_data.replace('SWITCH_URL:', '')
            try {
                const parsed = new URL(str_data)
                const isSafe = parsed.protocol === 'https:' && parsed.hostname === 'mail.google.com'
                if (!isSafe) return
            } catch {
                return
            }
            if (top) top.location.href = str_data
        }

        if (str_data.indexOf('TODOIST_INITED:') !== -1) {
            _IS_INITED = true
        }
    })

    // Notify iframe when email changes (for when iframe is already open)
    top.TDOpts.notifyIframeOfEmailChange = (): void => {
        // Check if iframe is visible (holder is displayed and not collapsed)
        if (holder && holder.style.display !== 'none' && !holder.collapsed) {
            const msg = {
                msg_type: 'GMAIL_MESSAGE_ADD',
                title: top.TDOpts.email_title || `${top.document.title}`,
                href: top.TDOpts.email_href || `${top.location.href}`,
            }

            postMessageToWindow(iframe.contentWindow, JSON.stringify(msg))
        }
    }

    // Quick add
    top.TDOpts.addAsTask = (options?: AddTaskOptions): void => {
        if (holder.style.display === 'none') {
            holder.style.display = 'block'
        }

        if (holder.collapsed) {
            collapseWindow()
            placeWindow()
        }

        const msg = {
            msg_type: 'SHOW_QUICK_ADD',
            title: options?.title || top.TDOpts.email_title || `${top.document.title}`,
            href: options?.href || top.TDOpts.email_href || `${top.location.href}`,
        }

        postMessageToWindow(iframe.contentWindow, JSON.stringify(msg))
    }
})()
